import { cn } from "@/lib/utils";

const Divider = ({ label }) => (
  <div className="my-10 flex items-center gap-4">
    <span className="h-px w-6 bg-[#C2A374]" />
    <span className="font-mono-ss text-[0.64rem] tracking-[0.2em] uppercase text-[#8C6A53]">{label}</span>
    <span className="h-px flex-1 bg-[#E2DDD5]" />
  </div>
);

const Callout = ({ title, text }) => (
  <aside className="my-10 border-l-2 border-[#C2A374] bg-[#EFECE6]/70 pl-6 pr-6 py-6">
    {title && <p className="ss-overline text-[#8C6A53] mb-2">{title}</p>}
    <p className="text-[1.02rem] leading-relaxed text-[#1A1C1E] font-light">{text}</p>
  </aside>
);

const Check = ({ items }) => (
  <ul className="my-8 space-y-3">
    {items.map((it, i) => (
      <li key={i} className="flex gap-4 items-start">
        <span className="mt-2 font-mono-ss text-[0.7rem] text-[#C2A374] shrink-0">{String(i + 1).padStart(2, "0")}</span>
        <span className="text-[1.05rem] leading-relaxed text-[#1A1C1E] font-light">{it}</span>
      </li>
    ))}
  </ul>
);

export const ArticleBody = ({ blocks }) => {
  return (
    <div className="ss-article">
      {blocks.map((b, i) => {
        switch (b.type) {
          case "lead":
            return (
              <p key={i} className="font-display text-2xl sm:text-[1.7rem] leading-snug text-[#1A1C1E] mb-8 font-light">
                {b.text}
              </p>
            );
          case "h2":
            return (
              <h2 key={i} className="font-display text-2xl sm:text-3xl font-normal text-[#1A1C1E] mt-12 mb-4 leading-tight">
                {b.text}
              </h2>
            );
          case "p":
            return (
              <p key={i} className="text-[1.08rem] leading-[1.8] text-[#3a3f44] mb-5 font-light">
                {b.text}
              </p>
            );
          case "list":
            return (
              <ul key={i} className="my-6 space-y-2.5 list-none">
                {b.items.map((it, j) => (
                  <li key={j} className="flex gap-3 text-[1.05rem] leading-relaxed text-[#3a3f44] font-light">
                    <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#8C6A53]" />
                    {it}
                  </li>
                ))}
              </ul>
            );
          case "checklist":
            return <Check key={i} items={b.items} />;
          case "callout":
            return <Callout key={i} title={b.title} text={b.text} />;
          case "divide":
            return <Divider key={i} label={b.label} />;
          case "quote":
            return (
              <blockquote key={i} className="my-10 relative pl-8">
                <span className="absolute left-0 top-0 font-display text-5xl text-[#C2A374] leading-none">“</span>
                <p className="font-display text-2xl sm:text-3xl font-light italic leading-snug text-[#1A1C1E]">{b.text}</p>
                {b.cite && <cite className="mt-3 block ss-overline not-italic text-[#8A9098]">{b.cite}</cite>}
              </blockquote>
            );
          default:
            return null;
        }
      })}
    </div>
  );
};

export default ArticleBody;
